import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

const TIER_LABEL = { pro: "Pro", premium: "Premium" };

export function UpgradePrompt({ title, message, minTier = "pro", testid = "upgrade-prompt" }) {
  const navigate = useNavigate();
  const tier = TIER_LABEL[minTier] || "Pro";
  return (
    <div data-testid={testid} className="mx-auto mt-10 max-w-lg rounded-2xl border border-border bg-card p-8 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-tertiary">
        <Lock className="h-6 w-6 text-brand" />
      </div>
      <h2 className="font-display text-2xl font-bold text-midnight">{title || `${tier} plan feature`}</h2>
      <p className="mx-auto mt-2 max-w-sm text-sm text-muted-foreground">
        {message || `This section is available on the ${tier} plan and above. Upgrade to unlock it — your existing data is safe and unchanged.`}
      </p>
      <button
        onClick={() => navigate("/billing")}
        data-testid="upgrade-prompt-cta"
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-brand px-5 py-3 text-sm font-bold text-white transition-transform hover:scale-105"
      >
        Upgrade to {tier}
        <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
}
